import XIcon from '@square-icons/react/16/UI/x';
import { IconButton } from '@squareup/dex-ui';
import { Box } from '@squareup/dex-ui-shared-base';
import { commonIconStyles } from '@squareup/dex-ui-shared-icon-styles';
import clsx from 'clsx';
import React, { FC } from 'react';

import { mobileNavHelperStyles } from './MobileNavShifter';
import styles from './mobile-nav.module.css';

const MobileNavVeil: FC<{ isOpen: boolean; onClick: () => void }> = ({
  isOpen,
  onClick,
}) => {
  return (
    <Box
      data-testid="reference-nav-mobile-veil"
      onClick={onClick}
      className={clsx(
        mobileNavHelperStyles.vars,
        styles.veil,
        isOpen && styles['mobile-nav-open']
      )}
    >
      <IconButton
        icon={
          <XIcon
            className={clsx(
              styles.close,
              commonIconStyles['icon-fill-current-color']
            )}
          />
        }
        noHoverStyling={true}
        trackingId="close-mobile-nav"
        margin={{ left: '2x', top: '4x' }}
      ></IconButton>
    </Box>
  );
};

export { MobileNavVeil };
